import React from 'react'

const Auth = React.createContext(null)

export default Auth
